import Intercom from '../components/document/Intercom'

// TODO: Rewrite all styles to use css modules so that we can tree shake

// styles
import '../styles/roboto.css'
import '../styles/ptserifcaption.css'
import '../styles/icons.css'
import '../styles/flexboxgrid.css'
import '../styles/vars.css'
import '../styles/base.css'
import '../styles/layout.css'
import '../styles/footer.css'

// vendor
import '../styles/vendor/nprogress.css'

// components
import '../styles/components/radio.css'
import '../styles/components/checkbox.css'
import '../styles/components/nav.css'
import '../styles/components/linkbutton.css'
import '../styles/components/separator.css'
import '../styles/animations.css'
import '../styles/components/setting-up.css'
import '../styles/components/passwords.css'
import '../styles/components/tooltip.css'
import '../styles/components/feature-list.css'
import '../styles/components/testimonial.css'
import '../styles/components/try-aurelius.css'
import '../styles/components/demo-aurelius.css'

// pages
import '../styles/home.css'
import '../styles/product.css'
import '../styles/about.css'
import '../styles/pricing.css'
import '../styles/usecases.css'
import '../styles/signup.css'
import '../styles/freetrial.css'
import '../styles/videos.css'
import '../styles/404.css'
import '../styles/features.css'
import '../styles/security-privacy.css'
import '../styles/landing.css'
import '../styles/demo.css'
import '../styles/platform-research.css'
import '../styles/solutions.css'
import '../styles/compare.css'
import { PropsWithChildren, useMemo } from 'react'
import useReCaptcha from '../hooks/useReCaptcha'

const isProd = process.env.NODE_ENV === 'production'

export const Layout = ({ children }: PropsWithChildren) => {
  const gclid = useMemo(() => {
    if (typeof window !== 'undefined') {
      const searchParams = new URLSearchParams(window?.location?.search || '')
      return searchParams.get('gclid')
    }
    return null
  }, [])
  useReCaptcha({
    key: process.env.RECAPTCHA_PUBLIC_KEY,
  })

  return (
    <>
      {children}
      {isProd && gclid && <Intercom gclid={gclid} />}
    </>
  )
}
